module.exports = __webpack_public_path__ + "img/afa.f2089f0e.png";